import React, { useEffect, useState } from 'react';

import { Button, Col, Form, Input, InputNumber, message, Row, Select, Space, Table, Typography } from 'antd';

import { getSerieCode } from '../../../api/Get';
import { postSerieCode } from '../../../api/Post';
import { searchSerie } from '../../../api/Search';

const { Text, Title } = Typography;

const columnsCode = [
  {
    dataIndex: 'code',
    defaultSortOrder: 'descend',
    key: 'code',
    sorter: (a, b) => a.code.localeCompare(b.code),
    title: 'Code',
  },
  {
    dataIndex: 'serie',
    key: 'serie',
    title: 'Série',
  },
  {
    dataIndex: 'nbEp',
    key: 'nbEp',
    title: 'Nb Ep',
  },
  {
    dataIndex: 'activation',
    key: 'activation',
    sorter: (a, b) => a.activation - b.activation,
    title: 'Activation',
  },
];

const SerieCode = () => {
  const [messageApi, contextHolder] = message.useMessage();

  const [msgErr, setMsgErr] = useState('');
  const [selectedSeries, setSelectedSeries] = useState();
  const [searchResult, setSearchResult] = useState([]);

  const [allCodes, setAllCodes] = useState([]);

  const [form] = Form.useForm();

  const onFinish = async values => {
    if (!values.idSerie) return setMsgErr('Il faut choisir une série');

    const res = await postSerieCode(values);
    if (res.error) messageApi.error(res.msg);
    else messageApi.success('Code créé');
  };

  const handleSearch = async newValue => {
    const res = await searchSerie(newValue);
    if (res) setSearchResult(res.series);
  };

  const onChange = async newValue => {
    console.log(newValue);
    const selection = searchResult[newValue.value];
    setSelectedSeries(selection);
    form.setFieldValue('idSerie', selection.id);
    form.setFieldValue('qtEp', selection.Seasons && selection.Seasons.length > 0 ? selection.Seasons[0].Episodes.length : 1);
  };

  const laodSerieCode = async () => {
    const res = await getSerieCode();
    if (res.success) setAllCodes(res.codes);
    else console.log(res.msg);
  };

  useEffect(() => {
    laodSerieCode();
  }, []);

  return (
    <>
      {contextHolder}
      <Space
        style={{
          backgroundColor: '#f8f9fa',
          border: '1px solid #dee2e6',
          borderRadius: 5,
          padding: 15,
          width: '100%',
        }}
        direction="vertical">
        <Title level={4} style={{ marginBottom: 20 }}>
          Générer codes série
        </Title>
        <Form
          form={form}
          name="basic"
          initialValues={{
            aboType: 1,
            addToReport: true,
            exportPDF: true,
            qtCode: 1,
            timeUnit: 'm',
          }}
          onFinish={onFinish}
          autoComplete="off"
          layout="vertical">
          <Row gutter={16}>
            <Col flex="auto">
              <Form.Item label="Code" name="code" rules={[{ message: 'Please input a code!', required: true }]}>
                <Input placeholder="PCL23TSP" maxLength={255} minLength={1} />
              </Form.Item>
            </Col>
            <Col flex="auto">
              <Form.Item label="Série" rules={[{ message: 'Please input a serie!', required: true }]}>
                <Select
                  style={{ width: '100%' }}
                  labelInValue
                  showSearch
                  placeholder={'Ma super série'}
                  defaultActiveFirstOption={false}
                  suffixIcon={null}
                  filterOption={false}
                  onSearch={handleSearch}
                  onChange={onChange}
                  notFoundContent={null}
                  options={(searchResult || []).map((d, index) => ({
                    label: d.name,
                    value: index,
                  }))}
                />
              </Form.Item>
              <Form.Item label="Série" name="idSerie" hidden>
                <Input placeholder="NBK" minLength={1} hidden />
              </Form.Item>
            </Col>
            <Col flex="auto">
              <Form.Item label="Nb épisode" name="qtEp" rules={[{ message: 'Please input a quantity!', required: true }]}>
                <InputNumber value={selectedSeries} min={1} max={200} />
              </Form.Item>
            </Col>
          </Row>

          <Form.Item>
            <Button type="primary" htmlType="submit">
              Enregistrer
            </Button>
          </Form.Item>
        </Form>
        <Text type="danger">{msgErr}</Text>
      </Space>
      <Space
        style={{
          backgroundColor: '#f8f9fa',
          border: '1px solid #dee2e6',
          borderRadius: 5,
          marginTop: 24,
          padding: 15,
          width: '100%',
        }}
        direction="vertical">
        <Title level={4} style={{ marginBottom: 20 }}>
          Tous les codes
        </Title>
        <Table
          style={{ marginTop: 8 }}
          bordered
          columns={columnsCode}
          dataSource={allCodes}
          pagination={false}
          scroll={{
            y: '70vh',
          }}
        />
      </Space>
    </>
  );
};

export default SerieCode;
